import { ReactElement } from "react";

import { Anchor } from "@newsela/angelou";

import { cellLinkCss } from "../Cells.style";

interface CellLinkListMoreProp {
  value: string[];
  href?: string;
}

const CellLinkListMore = ({
  value,
  href,
}: CellLinkListMoreProp): ReactElement => {
  const count = value?.length;
  const isLink = !!href;
  const hasMoreValues = count > 1;
  const usefulValue = value?.[0];

  if (!count) return <span>-</span>;

  if (isLink) {
    return (
      <Anchor
        href={href}
        __cssFor={{
          root: cellLinkCss,
        }}
      >
        <span>
          {hasMoreValues
            ? `${usefulValue || ""} & ${count - 1} more`
            : usefulValue}
        </span>
      </Anchor>
    );
  }

  return (
    <span>
      {hasMoreValues ? `${usefulValue || ""} & ${count - 1} more` : usefulValue}
    </span>
  );
};

export default CellLinkListMore;
